import { Spinner, Text } from "@fluentui/react-components";
import React from "react";

const SpinnerOverlay = () => {
    return (
        <div className="flex flex-col justify-center items-center absolute inset-0 z-1000 gap-3 text-(--colorNeutralForeground1) backdrop-blur-[1px]">
            <Spinner size="large" />
            <Text>Loading...</Text>
        </div>
    );
};

export default SpinnerOverlay;
